import { cva } from 'class-variance-authority';

export const popoverContentClasses = cva(
  [
    'fixed z-[var(--z-on-top)] max-h-[var(--popover-available-height,300px)] overflow-auto',
    'bg-white-50 rounded-2xl p-3',
    'drop-shadow-[0_2px_4px_rgba(0,0,0,0.1)]'
  ],
  {
    variants: {
      visibility: {
        visible: 'visible',
        hidden: 'invisible'
      }
    },
    defaultVariants: {
      visibility: 'hidden'
    }
  }
);
